/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { classnames } from 'Utils/classnames';
import { copyToClipboard } from 'Utils/copyToClipboard';
import Accordion from 'Components/Accordion';
import Icon from 'Components/Icon';
import { Button } from 'Components/Button';
import { accountList, menuList } from './MenuList';
import History from 'Store/history';
import MarketingIcons from 'Components/MarketingIcons';
import { Badge } from 'Components/Badge';
import { getHelpMenuItems, getStaticScreen } from 'Store/actions';
import EnvironmentManager from 'Utils/environmentManager';
import { getDisplayCommunicationSettings, toggleSideMenu, updateUserBalance } from 'Store/actions';
import { withMixpanel } from 'Utils/mixpanel';
import withPrivacyEye from 'Components/PrivacyEyeHOC';
import { doubleDigitDecimalFormatter } from 'Utils/decimalFormatter';
import ThemeSegmentedControl from 'Components/Theme/ThemeSegmentedControl';

class MenuAccount extends Component {
  constructor (props) {
    super(props);

    this.state = {
      popoverText: '',
      isAccountMenuOpen: false,
      fastDepositFlagValue: null,
    };
  }

  static propTypes = {
    getDisplayCommunicationSettings: PropTypes.func,
  };

  componentDidMount () {
    this.checkFastDepositABTest();
  }

  checkFastDepositABTest = async () => {
    try {
      const { mixpanel } = this.props;
      const FAST_DEPOSIT_AB_TEST_FLAG = EnvironmentManager.getMessageText({ key: 'fast_deposit_mixpanel_key_web' });
      if (mixpanel?.flags && typeof mixpanel.flags.get_variant_value === 'function') {
        const flagValue = await mixpanel.flags.get_variant_value(FAST_DEPOSIT_AB_TEST_FLAG);
        this.setState({ fastDepositFlagValue: flagValue });
      }
    } catch (error) {
      console.error('Fast Deposit A/B test flag error:', error);
    }
  };

  componentDidUpdate (prevProps) {
    const { auth } = this.props;
    const { isAuthenticated, data } = auth;
    const isMenuOpen = this.props.isMenuOpen;
    if (isMenuOpen !== undefined && isMenuOpen && isMenuOpen !== prevProps.isMenuOpen && !this.props.dontRequest) {
      this.props.getHelpMenuItems();
      this.props.getStaticScreen();
      if (isAuthenticated && data?.accessToken) {
        this.props.updateUserBalance();
      }
    }
  }


  componentWillUnmount () {
    clearTimeout(this.popoverTimeout);

  }

  showPopover = () => {
    if (!this.state.popoverText) {
      this.setState(
        {
          popoverText: 'Üye Numarası kopyalandı'
        },
        () => {
          this.popoverTimeout = setTimeout(() => {
            this.setState({
              popoverText: ''
            });
          }, 2000);
        }
      );
    }
  };

  toggleAccountMenu = () => {
    this.setState(prevProps => ({
      isAccountMenuOpen: !prevProps.isAccountMenuOpen
    }));
  }

  trackHamburgerMenuItemClick = itemName => {
    this.props.mixpanel.track('Click Hamburger Menu Item', {
      'Menu Item Name': itemName
    });
  }

  trackViewAccountTransactionsPage = clickPoint => {
    this.props.mixpanel.track('View Account Transactions Page', {
      'Click Point': clickPoint
    });
  }

  renderAccountMenuProfile = () => {
    const { data, isAuthenticated } = this.props.auth;
    const { isAccountMenuOpen } = this.state;
    const privacy = this.props.privacy;
    const { userId } = data;
    const eyeClass = classnames({
      'account-menu__profile__info__eye': true,
      'account-menu__profile__info__eye-close': !privacy?.isEyeOpen
    });

    const signUpButtonText = EnvironmentManager.getMessageText({ key: 'header_button_sign_up' }) || 'ÜYE OL';
    const loginButtonText = EnvironmentManager.getMessageText({ key: 'header_button_login' }) || 'GİRİŞ YAP';

    return isAuthenticated ? (
      <div className="account-menu__profile">

        <div onClick={ this.toggleAccountMenu }>
          { isAccountMenuOpen ? (
            <Icon className="accordion__status-icon" iconName={ 'svgArrowUp' } />
          ) : (
            <Icon className="accordion__status-icon" iconName={ 'svgDownArrow' } />
          ) }
          <div className="account-menu__profile__avatar">
            <i className="bly bly-avatar bly-grey bly-size36" />
          </div>
          <div className="account-menu__profile__info">
            <div className="account-menu__profile__info__main">
              <div>
                { privacy?.name }
              </div>
              <div className={ eyeClass } >
                <i onClick={ event => {
                  event.stopPropagation();
                  this.props.mixpanel.track('Member Info Visibility', {
                    'Visibility Value': privacy?.isEyeOpen ? 'Pasif' : 'Aktif'
                  });
                  privacy?.toggleEye();
                } } className={ privacy?.icon } />
              </div>
            </div>
            <div className="account-menu__profile__info__id" onClick={ event => {
              event.stopPropagation();
              this.props.mixpanel.track('Click Copy Member ID', {
                'Click Point': 'Hamburger Menu'
              });
              copyToClipboard(userId, this.showPopover);
            } }>
              <span>Üye No:</span>
              <label>{ userId }</label>
              <div className="account-menu__profile__info__id__icon">
                <i className="bly bly-copy-stroke bly-black-white bly-size12" />
              </div>
            </div>
          </div>
        </div>

        { isAccountMenuOpen
          && <div className='account-menu__links'>
            {
              accountList.map((listItem, index) => {
                if (listItem.path === '/hesabim/hizli-para-yatir') {
                  const CMS_FAST_DEPOSIT_SWITCH = EnvironmentManager.getMessageText({ key: listItem.visibleKeyProps }) === 'true';
                  const fastDepositFallback = EnvironmentManager.getMessageText({ key: 'deposit_page_fast_deposit_switch_v2_fallback' }) || '01';

                  let showFastDepositMenuItem = false;
                  if (CMS_FAST_DEPOSIT_SWITCH) {
                    const flagValue = this.state.fastDepositFlagValue;
                    const variant = flagValue != null ? String(flagValue) : fastDepositFallback;
                    if (variant === '2' || variant === '02') {
                      showFastDepositMenuItem = true;
                    } else if (variant === '1' || variant === '01') {
                      showFastDepositMenuItem = false;
                    } else {
                      showFastDepositMenuItem = fastDepositFallback === '02';
                    }
                  }
                  if (!showFastDepositMenuItem) {
                    return null;
                  }
                } else if (listItem.visibleKeyProps && !(EnvironmentManager.getMessageText({ key: listItem.visibleKeyProps }) === 'true')) {
                  return null;
                }
                const itemContent = listItem.contentKey
                  ? EnvironmentManager.getMessageText({ key: listItem.contentKey })
                  : listItem.content;
                return (
                  <Link key={ index } onClick={ () => {
                    this.trackHamburgerMenuItemClick(itemContent);
                    this.props.toggleSideMenu(false);
                    if (listItem.content === 'Para Yatırma') {
                      this.props.mixpanel.track('View Deposit Page', {
                        'Page Name': 'Hesabım'
                      });
                    }
                  } } title={ itemContent } className="account-menu__links__link" to={ listItem.path }>
                    { itemContent }
                  </Link>
                );
              })
            }
          </div> }
      </div>
    ) : (
      <div className="account-menu__login-buttons">
        <Link className="btn btn-register" to="/uye-ol" rel="nofollow" title={ signUpButtonText } onClick={ () => {
          this.props.mixpanel.track('Click Register Button in Hamburger Menu');
        } }>
          { signUpButtonText }
        </Link>

        <Link className="btn btn-login" to="/giris-yap" rel="nofollow" title={ loginButtonText } onClick={ () => {
          this.props.mixpanel.track('Click Login Button in Hamburger Menu');
        } }>
          { loginButtonText }
        </Link>
      </div>
    );
  };

  renderList = () => {
    const { auth, helpMenuCategories, unreadAnnouncementsCount, staticScreen } = this.props;

    const isZendeskActive = EnvironmentManager.getMessageText({
      key: 'is_zendesk_live',
    }) === 'true';


    let modifiedMenuList = menuList.map((item, index) => item.title === 'YARDIM' ? ({
      ...item,
      list: isZendeskActive ? [] : helpMenuCategories?.data,
      path: '/yardim/yardim-konulari'
    }) : item);


    // Sorumlu Oyun menuList'te statik tanımlı; servisten de gelirse çift görünmesin.
    let modifiedStaticList = staticScreen?.data?.filter(item => item.url !== '/sorumlu-bahis').map((item, index) => ({
      ...item,
      static: true,
      badgeNew: true,
    }));

    let mergeList = [...modifiedMenuList, ...modifiedStaticList];

    return mergeList.map((item, index) => {
      if (
        !item.isAuthRequired
        || (item.isAuthRequired && auth.isAuthenticated)
      ) {
        if (item.list?.length > 0) {
          return this.renderAccordionItem(item, index);
        } else {
          if (item.static) {
            return this.renderNotAccordionStaticItem(item, index, unreadAnnouncementsCount);
          } else {
            return this.renderNotAccordionItem(item, index, unreadAnnouncementsCount);
          }
        }
      } else {
        return null;
      }
    });
  };

  renderAccordionItem = (item, index) => {
    if (item.visibleKeyProps && !(EnvironmentManager.getMessageText({ key: item.visibleKeyProps }) === 'true')) {
      return null;
    }

    return (
      <Accordion key={ index } iconName={ item.iconName } title={ item.title } newBadge={ item.badgeNew }>
        { item.list.map((listItem, listIndex) => {
          if (listItem.show === false || (listItem.visibleKeyProps && !(EnvironmentManager.getMessageText({ key: listItem.visibleKeyProps }) === 'true'))) {
            return null;
          }

          return (
            <ul key={ listIndex }>
              <li className="accordion__content--list">
                <Link
                  to={ listItem.path }
                  title={ listItem.content }
                  onClick={ () => {
                    this.trackHamburgerMenuItemClick(listItem.content);
                    this.props.toggleSideMenu();
                  } }
                >
                  { listItem.content }
                </Link>
              </li>
            </ul>
          );
        }) }
      </Accordion>
    );
  };

  redirectRaffleUrl = () => {
    if (!this.props.auth?.data?.accessToken)
      History.push('/sans-oyunlari/esya-piyangosu');
    else {
      this.props.getDisplayCommunicationSettings().then(res => {
        if (this.props.auth?.data?.accessToken && res?.data?.displayable && !(res?.data?.contactPermission.campaignEmail && res?.data?.contactPermission.campaignSms && res?.data?.contactPermission.campaignCallCenter))
          History.push('/esya-piyangosu/iletisim-izinleri', { deeplinkParam: false });
        else {
          History.push('/sans-oyunlari/esya-piyangosu');
        }

      });
    }
  }

  redirectNotAccordionLink = item => {

    item.title === 'TRİBÜN' && this.props.mixpanel.track('Click Main Page Tribun', { 'Area Type': 'Hamburger' });
    item.title === 'KAMPANYALAR' && this.props.mixpanel.track('Click Main Page Campaigns', { 'Area Type:': 'Hamburger' });

    if (item.title === 'EŞYA PİYANGOSU') {
      return this.redirectRaffleUrl();
    } else if (item.title === 'YARDIM') {
      return window.open('https://yardim.bilyoner.com', '_blank');
    } else if (item.title === 'BİLYONER BLOG') {
      const blogLink = EnvironmentManager.getMessageText({ key: 'bilyoner_blog_footer_link' });
      return window.open(blogLink, '_blank');
    } else if (item.title === 'DÜNYA KUPASI NOSTALJİ') {
      History.push(item.path, { clickPoint: 'Hamburger Menü' });
    } else {
      History.push(item.path);
    }
  }

  renderNotAccordionItem = (item, index, unreadAnnouncementsCount) => {

    if (item.show === false) {
      return null;
    }

    if (item.visibleKeyProps && !(EnvironmentManager.getMessageText({ key: item.visibleKeyProps }) === 'true')) {
      return null;
    }

    return (
      <div key={ index }>
        <a title={ item.title } href={ item.path }
          className={ classnames({
            ...(item.className ? { [item.className]: true } : {}),
            'account-menu__list__not-accordion': true,
          }) }
          onClick={ e => {
            e.preventDefault();
            this.trackHamburgerMenuItemClick(item.title);
            this.props.toggleSideMenu();
            this.redirectNotAccordionLink(item);
          } }>
          <div className="account-menu__list__not-accordion__icon">
            { item.svgIconName
              ? <Icon iconName={ item.svgIconName } className="account-menu__list__not-accordion__icon__size" />
              : <i className={ `bly ${item.iconName} bly-black-white bly-size20` } /> }
          </div>
          <div className="account-menu__list__not-accordion__text">
            { item.title }
          </div>
          { item.badge && unreadAnnouncementsCount > 0 && <Badge className="account-info__avatar__badge">
            { unreadAnnouncementsCount }
          </Badge> }
          { item.badgeNew && <Badge isNew={ true } className={ item.className ?? 'avatar-resize' }>
            { 'Yeni' }
          </Badge> }
        </a>
        <hr className="account-menu__list__horizontal-line" />
      </div>
    );
  };

  renderNotAccordionStaticItem = (item, index, unreadAnnouncementsCount) => {
    if (item.show === false) {
      return null;
    }
    return (
      <div key={ index }>
        <div className="account-menu__list__not-accordion" onClick={ () => {
          this.trackHamburgerMenuItemClick(item.name?.toUpperCase());
          this.props.toggleSideMenu();
          History.push('/bilyoner' + item.url);
        }
        }>
          <div className="account-menu__list__not-accordion__icon">
            <img alt={ item.name?.toUpperCase() } className="account-menu__list__not-accordion__icon__size" src={ item.iconUrl } />
          </div>
          <div className="account-menu__list__not-accordion__text">
            { item.name?.toUpperCase() }
          </div>
          { item.badge && unreadAnnouncementsCount > 0 && <Badge className="account-info__avatar__badge">
            { unreadAnnouncementsCount }
          </Badge> }
          { item.badgeNew && <Badge isNew={ true } className="avatar-resize">
            { 'Yeni' }
          </Badge> }
        </div>
        <hr className="account-menu__list__horizontal-line" />
      </div>
    );
  };

  render () {
    const { auth, platform, device } = this.props;
    const { isAuthenticated, data } = auth;
    const { amountInfoList = [], balance } = data || {};
    const moneyBalance = amountInfoList?.find(item => item?.amountType === 'MONEY')?.amount || 0;
    const bilyonerBonusBalance = amountInfoList?.find(item => item?.amountType === 'BILYONER_BONUS')?.amount || 0;
    const earnedBonusBalance = amountInfoList?.find(item => item?.amountType === 'EARNED_BONUS')?.amount || 0;
    const notWithdrawableAmount = amountInfoList?.find(item => item?.amountType === 'NOT_WITHDRAWABLE_AMOUNT')?.amount || 0;

    const { popoverText } = this.state;
    const totalBalanceTitle = EnvironmentManager.getMessageText({ key: 'hm_total_balance_title' }) || 'Toplam Bakiye:';
    const tlBalanceTitleMobile = EnvironmentManager.getMessageText({ key: 'hm_tl_balance_title' }) || 'TL';
    const bpBalanceTitleMobile = EnvironmentManager.getMessageText({ key: 'hm_bp_balance_title' }) || 'BP';
    const spBalanceTitleMobile = EnvironmentManager.getMessageText({ key: 'hm_sp_balance_title' }) || 'ŞP';

    return (
      <div className="account-menu">
        { this.renderAccountMenuProfile() }
        { isAuthenticated && <div className='account-menu__balance-container'>
          <div className="account-menu__balance-container__balance-box" onClick={ () => {
            this.trackViewAccountTransactionsPage('Total Balance');
            this.props.toggleSideMenu();
            History.push('/hesabim/hesap-hareketlerim');
          } }>
            <div className="account-menu__balance-container__balance-box__balance" >
              <span>{ totalBalanceTitle }</span>
              <div className='account-menu__balance-container__balance-box__balance__balance-with-icon'>
                <strong className="account-menu__balance-container__balance-box__balance__balance-with-icon__amount">{ doubleDigitDecimalFormatter(balance) } TL</strong>
                <div className='account-menu__balance-container__balance-box__balance__icon'>
                  <Icon iconName='svgArrowRightWhite' />
                </div>
              </div>
            </div>
            <div className='account-menu__balance-container__balance-box__balances'>
              <div className='balance-item' onClick={ event => {
                event.stopPropagation();
                this.trackViewAccountTransactionsPage('TL Balance');
                this.props.toggleSideMenu();
                History.push('/hesabim/hesap-hareketlerim');
              } }>
                <span dangerouslySetInnerHTML={ { __html: tlBalanceTitleMobile } } />
                <strong>{ doubleDigitDecimalFormatter(moneyBalance + notWithdrawableAmount) }</strong>
              </div>
              <div className='balance-item' onClick={ event => {
                event.stopPropagation();
                this.trackViewAccountTransactionsPage('BilyonPuan Balance');
                this.props.toggleSideMenu();
                History.push('/hesabim/hesap-hareketlerim');
              } }>
                <span dangerouslySetInnerHTML={ { __html: bpBalanceTitleMobile } } />
                <strong>{ doubleDigitDecimalFormatter(bilyonerBonusBalance) }</strong>
              </div>
              <div className='balance-item' onClick={ event => {
                event.stopPropagation();
                this.trackViewAccountTransactionsPage('ŞansPuan Balance');
                this.props.toggleSideMenu();
                History.push('/hesabim/hesap-hareketlerim');
              } }>
                <span dangerouslySetInnerHTML={ { __html: spBalanceTitleMobile } } />
                <strong>{ doubleDigitDecimalFormatter(earnedBonusBalance) }</strong>
              </div>
            </div>
          </div>
        </div> }
        { isAuthenticated && <div className="account-menu__money-buttons-container">
          <Link to="/hesabim/para-yatir" onClick={ () => {
            this.props.toggleSideMenu();
            this.props.mixpanel.track('View Deposit Page', {
              'Page Name': 'Hamburger Menu'
            });
          } }>
            <Button className='btn--primary btn--half-round btn--block'>Para Yatır</Button>
          </Link>
          <Link to={ { pathname: '/hesabim/para-cek', state: { pageName: 'Hamburger Menu' } } } onClick={ () => {
            this.props.toggleSideMenu();
          } }>
            <Button className='btn--outline btn--half-round btn--block'>Para Çek</Button>
          </Link>
        </div> }

        <ThemeSegmentedControl />

        <div className="account-menu__list">
          { this.renderList() }
        </div>

        { isAuthenticated && <div className="account-menu__logout-button" onClick={ () => {
          this.trackHamburgerMenuItemClick('Çıkış Yap');
          History.push('/cikis-yap');
        } }>
          Çıkış Yap
        </div> }

        <MarketingIcons platform={ platform } device={ device } />

        <div
          className={ classnames({
            'account-menu__popover': true,
            'account-menu__popover--show': popoverText
          }) }
        >
          <div className="account-menu__popover-text">{ popoverText }</div>
        </div>
      </div>
    );
  }
}

MenuAccount.propTypes = {
  auth: PropTypes.object.isRequired,
  getUserTribunToken: PropTypes.func,
  openModal: PropTypes.func,
  getHelpMenuItems: PropTypes.func,
  history: PropTypes.object,
  helpMenuCategories: PropTypes.object,
  platform: PropTypes.string,
  device: PropTypes.object,
  unreadAnnouncementsCount: PropTypes.number,
  staticScreen: PropTypes.object,
  getStaticScreen: PropTypes.func,
  mixpanel: PropTypes.object,
  toggleSideMenu: PropTypes.func,
  privacy: PropTypes.object,
  isMenuOpen: PropTypes.bool,
  dontRequest: PropTypes.bool,
  updateUserBalance: PropTypes.func,
};

const mapStateToProps = state => ({
  helpMenuCategories: state.cms.helpMenuCategories,
  staticScreen: state.staticScreen,
  auth: state.auth,
});

export default connect(mapStateToProps, { getHelpMenuItems, getStaticScreen, getDisplayCommunicationSettings, toggleSideMenu, updateUserBalance })(withMixpanel(withPrivacyEye(MenuAccount)));
